var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"py-5 bg-light"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"text-center mb-4"},[_vm._v("国内分布")]),_c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"china-map"}})])])
}]

export { render, staticRenderFns }